import toUTCDate from './toUTCDate';

// A calendar task belongs to the Niko flow when its Date of Service is on or after the
// facility's Transition Date - the date the facility switches from the BT flow to the
// Niko flow (ISG-2806). Facilities with no Transition Date keep the "IsNiko" flag behavior,
// because the facilities transition in phases and the field is populated manually.
export default function isNikoFlowTask(facility, dateOfService) {
    if (!facility) return false;
    // No Transition Date means the facility has not transitioned, so keep the old "IsNiko" logic.
    if (!facility.transitionDate || !dateOfService) return facility.isNiko;
    return toUTCDate(dateOfService, false, 'YYYY-MM-DD') >= toUTCDate(facility.transitionDate, false, 'YYYY-MM-DD');
}
